import { SERVICES } from "../lib/content";
import { Reveal, Eyebrow, MaskLines } from "./Reveal";
import { TiltCard } from "./TiltCard";

export const Services = () => (
  <section id="servicos" data-testid="services-section" className="relative py-24 sm:py-32">
    <div className="pointer-events-none absolute right-0 top-20 h-96 w-96 rounded-full bg-[#087BFF]/10 blur-[120px]" />
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
        <div className="lg:col-span-7">
          <Reveal><Eyebrow>01 — Serviços</Eyebrow></Reveal>
          <h2 className="font-display mt-6 text-3xl font-semibold leading-[1.05] tracking-tight sm:text-5xl">
            <MaskLines inView lines={[<>Soluções digitais para levar</>, <>sua empresa <span className="text-grad">mais longe.</span></>]} />
          </h2>
        </div>
        <Reveal delay={0.2} className="lg:col-span-5">
          <p className="text-base text-slate-300 md:text-lg">Desenvolvemos experiências digitais que valorizam sua marca e ajudam seu negócio a se destacar no mercado.</p>
        </Reveal>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={(i % 3) * 0.08} className={s.span}>
            <TiltCard className="h-full" data-testid={`service-card-${i}`}>
              <div className="relative flex h-full min-h-[260px] flex-col overflow-hidden rounded-3xl border border-white/10 bg-gradient-to-br from-[#181D27] to-[#0D111A] p-7 sm:p-8">
                <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 rounded-full bg-[#087BFF]/0 blur-3xl transition-colors duration-500 group-hover:bg-[#087BFF]/25" />
                <div className="flex items-start justify-between" style={{ transform: "translateZ(40px)" }}>
                  <span className="flex h-14 w-14 items-center justify-center rounded-2xl border border-[#087BFF]/30 bg-[#087BFF]/10 shadow-[inset_0_0_20px_rgba(8,123,255,0.25)] transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-110">
                    <s.icon className="h-6 w-6 text-[#00C8FF]" />
                  </span>
                  <span className="font-mono-jl text-xs text-slate-400">0{i + 1}</span>
                </div>
                <div className="mt-auto pt-10" style={{ transform: "translateZ(24px)" }}>
                  <h3 className="font-display text-xl font-semibold text-white sm:text-2xl">{s.title}</h3>
                  <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-300 sm:text-base">{s.text}</p>
                </div>
              </div>
            </TiltCard>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
